export const assessments = {
  verifiers: "Verificadores",
  favorite_assessments: "Avaliações favoritas",
  creation: {
    assessment_created: "A avaliação foi criada com sucesso.",
    assessment_is_being_created:
      "Sua avaliação está sendo criada. Por favor, aguarde um momento enquanto concluímos o processo.",
    confirmation_modal: {
      title_with_warnings: "Alguns sites não herdarão dados",
      title_without_warnings: "Criar Avaliação",
      description_with_warnings:
        "Você selecionou uma avaliação anterior como ponto de partida, mas os sites não herdarão todos os dados porque faltam alguns padrões.",
      sites_warning_subtitle: "Os seguintes sites herdarão dados parciais da avaliação anterior:",
      continue_confirmation: "Deseja continuar criando a avaliação mesmo assim?",
      create_anyway: "Criar Mesmo Assim",
    },
  },
  verification: {
    verification_cannot_be_undone: "Uma vez verificado, esta ação não pode ser desfeita",
    assessment_verification: "Verificação da avaliação",
    verifies_this_assessment_on_behalf_of: "verifica esta avaliação em nome de:",
    verified_this_assessment: "verificou esta avaliação",
    verifies_this_assessment: "verifica esta avaliação",
    date_of_verification: "Data de quando a verificação foi realizada",
    please_enter_verifier: "Por favor, insira o verificador",
    send_verification: "Enviar Verificação",
    verifier: "Verificador",
  },
  approval: {
    date_of_approval: "Data da aprovação",
  },
  related_questions: "Questões Relacionadas",
  data_providers_assign: {
    override_warning: "As atribuições de fornecedor de dados existentes serão substituídas.",
    data_provider_overview: "Visão geral dos fornecedores de dados",
  },
  complete_assessment: {
    action: "Concluir avaliação",
    confirm_completion: "Confirmar conclusão da avaliação",
    upload_additional_files_to_sites: "Enviar arquivos adicionais para os sites",
    upload_file_here: "Por favor, envie um arquivo aqui para confirmar a conclusão da avaliação.",
    files_assigned_to_whole_assessment: "Arquivos atribuídos a toda a avaliação",
    i_am_aware_that_i_cannot_undo_this_action:
      "Estou ciente de que uma vez que eu decida concluir a avaliação, isso não pode ser desfeito. Este processo é irreversível.",
    assessment_completion_confirmation:
      "A avaliação foi concluída com sucesso. Você pode encontrá-la na aba 'Avaliação Concluída'.",
  },
  previous_assessment: {
    label: "Avaliação anterior (opcional)",
    description:
      "Você pode selecionar uma avaliação anterior como ponto de partida para sua nova avaliação. Os sites da avaliação selecionada serão destacados com um ícone no menu suspenso abaixo, e todos os dados aplicáveis serão copiados para sua nova avaliação. <a>Saiba mais</a>",
  },
  starting_point: "Ponto de partida da avaliação",
  reviewers_overview: "Visão geral dos revisores",
  back_to_overview: "Voltar para visão geral",
  site_assessment_progress: "Progresso da avaliação do site",
  Active_assessments: "Avaliações ativas",
  Completed_assessments: "Avaliações concluídas",
  add_a_comment: "Adicionar um comentário",
  Add_evidence: "Adicionar evidência",
  Add_external_verification: "Adicionar etapa de verificação externa",
  Add_Step: "Adicionar etapa de revisão",
  approval_cannot_be_undone: "Uma vez aprovado, esta ação não pode ser desfeita",
  "After_approval,_You_can't_undo_approval": "Após a aprovação, você não pode desfazer a aprovação.",
  All_assessments: "Todas as avaliações",
  All_Sites: "Todos os sites",
  all_sites_description:
    "Quaisquer alterações que você fizer na seleção de padrões aqui serão aplicadas a todos os sites que você selecionou para esta avaliação.",
  Applicability: "Aplicabilidade",
  Approve: "Aprovar",
  approved_this_assessment: "aprovou esta avaliação",
  Approver: "Aprovador",
  approves_this_assessment: "aprova esta avaliação",
  approves_this_assessment_on_behalf_of: "aprova esta avaliação em nome de:",
  archive_assessment_confirmation:
    "Tem certeza? Uma vez excluída, esta avaliação e todos os dados relacionados, incluindo relatórios, não estarão mais acessíveis.",
  areas_of_improvement: "Áreas de melhoria",
  Assessment_approval: "Aprovação da avaliação",
  Assessment_comment_overview: "Visão geral dos comentários da avaliação",
  Assessment_list: "Lista de avaliações",
  assessment_name: "Nome da avaliação",
  assessment_of_conformity: "Avaliação de conformidade",
  Assessment_report: "Relatório de avaliação",
  Assessment_standard_setup: "Configuração de padrões da avaliação",
  Assessment_update: "Atualização da avaliação",
  assessmentDetails: "Detalhes da avaliação",
  Assessments: "Avaliações",
  assign_data_providers: "Atribuir Fornecedores de Dados",
  Assign_data_providers_to_selected_themes: "Atribuir fornecedores de dados aos temas selecionados",
  assign_reviewers: {
    "After_confirmation,_this_assigment_will_be_deleted": "Após a confirmação, esta atribuição será excluída.",
    After_you_confirm_the_section:
      "Você pode atribuir revisores e grupos de revisores a temas individuais para cada etapa de revisão que sua avaliação possui.",
    Assign_Reviewers: "Atribuir Revisores",
    Assign_Reviewers_to_the_Theme: "Atribuir Revisores ao(s) tema(s) selecionado(s)",
    Assign_to_selected: "Atribuir aos selecionados",
    Assign_Verifiers: "Atribuir Verificadores",
    Assign_Verifiers_to_an_assessment: "Atribuir Verificadores a uma avaliação",
    Assigned_Themes: "Temas Atribuídos",
    Delete_assigment: "Excluir atribuição",
    Select_Reviewer_for_each_theme: "Atribuir Revisores para cada tema ou grupo de temas",
    Selected_Theme: "Tema Selecionado",
    Step_stepNumber_External_Verification: "Etapa {{stepNumber}}: Verificação Externa",
    There_are_no_assigned_themes: "Não há temas atribuídos.",
    There_are_no_unassigned_themes: "Não há temas não atribuídos.",
    Unassigned_Themes: "Temas Não Atribuídos",
    Use_this_window_to_assign_multiply_reviewers_to_selected_themes:
      "Use esta janela para atribuir revisor(es) ao(s) tema(s) selecionado(s).",
    Verifiers: "Verificadores",
    View_assessment: "Ver avaliação",
  },
  assign_themes_description:
    "Após atribuir temas, os fornecedores de dados serão encarregados de preencher as respostas\n          da avaliação para seu(s) tema(s) atribuído(s). Nem todos os temas precisam ser atribuídos para\n          prosseguir, mas um tema deve ser atribuído para que a avaliação de seus requisitos\n          relacionados possa prosseguir.",
  assign_themes_header: "Atribuir fornecedor de dados para cada tema",
  Assigned_Corporate_Coordinator: "Coordenador Corporativo Atribuído",
  assigned_themes: "Temas atribuídos",
  associated_requirements: "Requisitos associados",
  click_to_select: "Clique para selecionar arquivos do seu computador ou arraste e solte.",
  Closing_steps: "Etapas de fechamento",
  Comment: "Comentário",
  Comment_and_evidence: "Comentário e evidência",
  comments: "Comentários",
  Conformity_assessment: "Avaliação de conformidade",
  conformity_description:
    "Conformidade refere-se ao cumprimento de um requisito e pode exigir evidências para demonstrar tanto o processo quanto a implementação, dependendo da expectativa declarada.",
  Conformity_level: "Nível de conformidade",
  Conformity_level_description:
    "O nível de conformidade mede a conformidade com um padrão em termos de desempenho e qualidade. É usado para garantir que critérios específicos de qualidade, segurança ou regulamentares sejam atendidos para um produto, serviço ou processo.",
  copy_answer: {
    confirmation: "Copiar estes dados resultará na substituição de quaisquer dados de rascunho existentes.",
    Filter: "Filtrar",
    site: "Site",
    status: "Status",
  },
  Copy_this: "Copiar isto",
  clarifying_notes: "Notas de esclarecimento",
  Corporate_coordinator_assigned: "Coordenador Corporativo atribuído a esta avaliação",
  corporate_guidance: "Orientação Corporativa",
  Country: "País",
  Create_assessment: "Criar Avaliação",
  Critical: "Crítico",
  Data_Provider_Assignment: "Atribuição de Fornecedor de Dados",
  Data_providers: "Fornecedores de dados",
  Data_providers_overview: "Visão geral dos fornecedores de dados",
  Default_View: "Visualização Padrão",
  Delete_evidence: "Excluir evidência",
  Delete_evidence_confirmation_message: "Após a confirmação, esta evidência será excluída deste protocolo.",
  delete_evidences_description: "Após a confirmação, esta evidência será excluída deste protocolo.",
  Delete_requirement: "Excluir requisito",
  Description: "Descrição",
  Due_date: "Data de vencimento",
  edit_assessment: "Editar avaliação",
  Edited_by: "Editado por",
  erm_mapping_note: "Nota de Mapeamento ERM",
  Evidence_files: "Arquivos de evidência",
  evidences: "Evidências",
  External_Verification: "Verificação Externa",
  External_verifiers_can_see_comments: "Verificadores externos podem ver comentários.",
  External_verifiers_have_been_added_and_they_can_read_comments_made_from_this_point_forward:
    "Verificadores externos foram adicionados e eles podem ler comentários feitos a partir deste ponto em diante.",
  File: "Arquivo",
  File_upload_error: "Erro no envio do arquivo",
  Fill_in_Assessment_Details: "Preencher Detalhes da Avaliação",
  Filter_by_site: "Filtrar por site",
  Filter_by_status: "Filtrar por status",
  Filters: "Filtros",
  ghost_question_warning:
    "Esta questão não é mais válida para esta avaliação devido à atualização recente do protocolo. Por favor, <docsLink>clique aqui</docsLink> para ler nossa documentação e saber mais sobre o protocolo e sua atualização.",
  Go_back_to_assessments: "Voltar para avaliações",
  informative: "Informativo",
  internal_audit_awareness:
    "Estou ciente de que o processo de auditoria ou avaliação interna está conectado aos requisitos associados. *",
  Last_edited: "Última edição",
  make_change_protocol_confirm: "Tem certeza de que deseja publicar as alterações?",
  make_change_protocol_confirm_description:
    "Considere deixar um comentário para fornecer contexto para outros usuários sobre as alterações que você fez.",
  Modify_responses: "Modificar respostas",
  Needs_review: "Precisa de revisão",
  Next_to_review: "Próximo para revisão",
  No_assessments_match_the_search_criteria: "Nenhuma avaliação corresponde aos critérios de pesquisa.",
  no_assigned_themes: "Não há temas atribuídos.",
  No_data_provider_assigned: "Nenhum fornecedor de dados atribuído",
  No_more_Protocol_Questions_to_review_at_the_moment: "Não há mais Questões de Protocolo para revisar no momento.",
  no_reviewers_assigned: "Nenhum revisor atribuído",
  no_reviewer_assignments: "Nenhuma atribuição de revisor para exibir",
  no_unassigned_themes: "Não há temas não atribuídos.",
  normative: "Normativo",
  Notice: "Aviso",
  on_behalf_of: "em nome de:",

  Please_enter_a_comment: "Por favor, insira um comentário",
  Please_enter_the_approver: "Por favor, insira o aprovador",
  Please_select_at_least_one_standard:
    "Você deve ter pelo menos um padrão para cada site selecionado. Por favor, volte e desmarque um site se você não deseja avaliá-lo.",
  Please_upload_a_file_here_to_confirm_approval_from_your_superior:
    "Por favor, envie um arquivo aqui para confirmar a aprovação de seu superior",
  Previous: "Anterior",
  Publish_changes: "Publicar alterações",
  Question_status: "Status da questão",
  Reference: "Referência",
  Reference_data: "Dados de referência",
  release_drop: "Solte para liberar os arquivos aqui.",
  Report_link: "Link do relatório",
  reset_default_all_description:
    "Quaisquer alterações que você fizer na seleção de padrões aqui serão aplicadas a todos os sites que você selecionou para esta avaliação.",
  Review_steps: "Etapas de revisão",
  Reviewed_by: "Revisado por",
  reviewer_assignment_not_available_as_no_assingments_made_yet:
    "A visão geral de atribuição de revisores ainda não está disponível, pois nenhuma atribuição foi feita ainda.",
  Reviewers: "Revisores",
  Role: "Função",
  Search_assessment_by_site_name_or_assessment_name: "Pesquisar avaliação por nome do site ou nome da avaliação",
  Search_standard_by_name: "Pesquisar padrão por nome",
  Select_data_providers: "Selecionar fornecedores de dados",
  self_assessment_rating: {
    does_not_meat: "Não atende",
    fully_meets: "Atende totalmente",
    not_applicable: "Não aplicável",
    partially_meets: "Atende parcialmente",
    substantially_meets: "Atende substancialmente",
  },
  Self_assessment_steps: "Autoavaliação - etapas",
  "Self-assessment": "Autoavaliação",
  Send_Approval: "Enviar Aprovação",
  Site: "Site",
  Site_coordinator: "Coordenador do site",
  Site_coordinators: "Coordenadores de sites",
  Site_List: "Lista de Sites",
  Site_name: "Nome do site",
  site_setup: "Configuração de {{siteName}}",
  Sites: "Sites",
  Staff_and_dates_setup: "Configuração de equipe e datas",
  stakeholders_awareness:
    "Estou ciente de que o engajamento das partes interessadas é necessário para implementar os requisitos associados. *",
  standard_guidance: "Orientação do Padrão",
  "Standards_not_included_in_this_assessment_will appear_grayed-out_To_view_other_standards":
    "Padrões não incluídos nesta avaliação aparecerão esmaecidos. Para ver outros padrões mapeados para esta Questão de Protocolo, clique no ícone 'Ver'.",
  "Standards_not_included_in_this_assessment_will_appear_grayed-out":
    "Padrões não incluídos nesta avaliação aparecerão esmaecidos.",
  status: {
    all_questions: "Todas as Questões",
    answered: "Respondido",
    assigned_to_me: "Atribuído a mim",
    declined: "Recusado",
    in_draft: "Em rascunho",
    in_review: "Em revisão",
    not_answered: "Não Respondido",
    reviewed: "Revisado",
    unassigned: "Não atribuído",
  },
  Step: "Etapa",
  Step_1_Data_Provider_Assignment: "Etapa 1: Atribuição de Fornecedor de Dados",
  "Step_2_Self-assessment": "Etapa 2: Autoavaliação",
  submit_for_review: "Enviar para revisão",
  sumbit_protocol_confirm: "Enviar questão de protocolo para revisão",
  sumbit_protocol_confirm_description: "Após a confirmação, esta questão de protocolo será enviada para revisão.",
  tasks_comparison: {
    areas_of_improvement: " Áreas de melhoria",
    assessment_of_conformity: "Avaliação de conformidade",
    Back_to_the_assessment_list: "Voltar para a lista de Avaliações",
    Comparison_view: "Visualização de comparação",
    conformity_level: "Nível de conformidade",
    evidences: "Evidências",
    field_name: "Nome do campo",
  },
  taskstatus: {
    declined: "Esta Questão de Protocolo foi recusada.",
    in_review: "Esta Questão de Protocolo foi enviada para a próxima rodada de revisão.",
    reviewed: "Esta Questão de Protocolo foi revisada.",
    not_submitted_for_review: "Esta Questão de Protocolo ainda não foi enviada para revisão.",
    unassigned: "Esta Questão do Protocolo ainda não foi atribuída a ninguém.",
  },
  The_standards_you_select_impact_the_themes:
    "Apenas os padrões selecionados na configuração do site estão disponíveis para personalização.",
  Themes_are_not_assigned_yet:
    "Os Fornecedores de Dados ainda não foram atribuídos. O Coordenador do Site deve atribuir Fornecedores de Dados para cada tema antes de prosseguir.",
  There_are_currently_no_questions_that_are_available_for_this_Site:
    "No momento, não há questões disponíveis para este Site.",
  There_are_no_assessments: "Não há avaliações.",
  This_is_a_Critical_requirement:
    "Este é um Requisito Crítico estabelecido pelo Conselho IRMA para obter qualquer Nível de Realização no Sistema IRMA.",
  This_is_data_provide_view: "Visualização do Fornecedor de Dados",
  This_is_review_view: "Visualização do Revisor",
  Type_here_to_add_description: "Digite aqui para adicionar descrição",
  unassigned_themes: "Temas não atribuídos",
  update_assessment: "Atualizar avaliação",
  Upload_an_evidence: "Enviar uma evidência",
  Upload_evidence: "Enviar evidência",
  Verifiers: "Verificadores",
  Verifiers_have_access_to_comments_that_are_made_after_they_are_assigned:
    "Verificadores têm acesso aos comentários feitos após serem atribuídos. Eles não podem acessar comentários feitos antes da atribuição.",
  approved: "Aprovado",
  verified: "Verificado",
  verify: "Verificar",
  view_assessment: "Ver avaliação",
  View_conversation: "Ver conversa",
  View_conversation_another_comments: "Ver conversa (+{{another_comments}})",
  You_can_reorder_reviewers_using_drag_and_drop: "Você pode reordenar revisores usando arrastar e soltar",
  means_of_verification: "Meios de verificação",
  evidence_examples: "Exemplos de evidência",
  "You_can't_deselect_a_site": "Você não pode desmarcar um site.",
  "Your_changes_are_not_auto-saved_Click_the_Publish_Changes_button_to_save_and_publish_your_changes":
    "Suas alterações não são salvas automaticamente. Clique no botão 'Publicar Alterações' para salvar e publicar suas alterações.",
  "Your_standard_setup_cannot_be_updated_as_your_assessment_isn't_employing_the_latest_protocol_set":
    "Sua configuração padrão não pode ser atualizada porque sua avaliação não está empregando o conjunto de protocolos mais recente. Entre em contato com a equipe de suporte da ERM para obter assistência.",
  theme_progress: {
    title: "Progresso do tema",
    site_assessment_label: "Avaliação do local",
    all_site_assessments: "Todas as avaliações de locais",
    no_data: "Nenhum dado de tema disponível",
    axis_labels: {
      themes: "Temas",
      task_count: "Contagem de tarefas",
    },
    status: {
      unassigned: "Não atribuído",
      in_draft_unanswered: "Rascunho não respondido",
      in_draft_answered: "Rascunho respondido",
      declined: "Recusado",
      in_review: "Em revisão",
      reviewed: "Revisado",
    },
  },
} as const;
